
import { Component, Prop, Vue } from 'vue-facing-decorator';
import { ParticipantGroups } from '@/entities/ParticipantGroups';
import { FetchData, Root } from '@/main';
@Component({})
export default class CreateGroup extends Vue {
  @Prop() groups!: ParticipantGroups[];
  private maxLength = 100;
  private isMobileView = false;
  private localGroup: ParticipantGroups = ParticipantGroups.createEmpty();
  private anyError = false;
  private errorMessage = '';
  private isCreateNewGroupBtnDisabled = false;
  private mounted() {
    (this.$refs.groupName as HTMLElement).focus();
    if (window.innerWidth <= 767) {
      this.isMobileView = true;
    } else {
      this.isMobileView = false;
    }
  }
  private CancelGroupCreation() {
    this.$emit('display-group-creation', false);
  }
  // Function to create a new group
  private CreateGroup() {
    let doesGroupExists = false;
    // Checking whether group name is empty
    if(this.localGroup.Name === '') {
      this.errorMessage = this.$t('Participants.Groups.NameFieldEmpty').toString();
    } else {
      // Checking whether the group name already exists
      this.groups.forEach((item)=> {
        if(item.Name === this.localGroup.Name) {
          doesGroupExists = true;
          this.errorMessage = this.$t('Participants.Groups.GroupAlreadyExists').toString();
          return;
        }
      });
    }
    if(doesGroupExists || this.localGroup.Name === '') {
      this.anyError = true;
    } else {
      this.isCreateNewGroupBtnDisabled = true;
      // api hit for creating group and response is Id and Name
      FetchData('/Participant/EditParticipantGroup', JSON.stringify({
        participantGroupdto:this.localGroup,
      }))
        .then((response) => {
          // checking success or not
          if(response !== null && response !== undefined) {
            // if success is true
            // assigning Id and Name
            this.localGroup.Id = response.Id;
            this.localGroup.Name = response.Name;
            // any error is false
            this.anyError = false;
            // closing modal popup
            this.$emit('display-group-creation', false);
            // emitting new created group
            this.$emit('new-created-group', this.localGroup);
            Root.emit('new-created-group', this.localGroup);
            this.isCreateNewGroupBtnDisabled = false;
          }  else {
            // checking success or not if success is false show error
            if (response.Data.Success === false) {
              doesGroupExists = true;
              this.errorMessage = this.$t('Participants.Groups.GroupAlreadyExists').toString();
              this.anyError = true;
              this.isCreateNewGroupBtnDisabled = false;
              return;
            }
          }
        })
        .catch(() => {
          // Log error if required
        });
    }
  }
}
